var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 91,
    viewBox: "0 0 71 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.4393 0H3.55006C1.59268 0 0 1.5925 0 3.55006V71.0057C0 72.9633 1.5925 74.5558 3.55006 74.5558H7.14243C7.38877 74.5558 7.62391 74.4536 7.79205 74.2736L62.8008 15.3578C62.9544 15.1933 63.0399 14.9764 63.0399 14.7514V3.60054C63.04 1.61525 61.4248 0 59.4393 0V0Z",
    fill: "url(#paint0_linear_1671_6298)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2402 21.9494V77.2265C70.2402 79.1852 68.6477 80.7776 66.6908 80.7776H9.80699C7.84836 80.7776 6.25586 79.1852 6.25586 77.2265V10.2154C6.25586 8.25851 7.84836 6.66602 9.80699 6.66602H54.955L56.5973 8.30828L70.2402 21.9494Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2402 21.9497V77.2268C70.2402 79.1855 68.6477 80.778 66.6908 80.778H9.80699C7.84836 80.778 6.25586 79.1855 6.25586 77.2268V76.3346H63.0064C64.9881 76.3346 66.5949 74.7279 66.5949 72.7444V21.9497L56.5973 8.30859L70.2402 21.9497Z",
    fill: "#D4DCE8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2402 21.9494H66.5949L56.1246 21.9476C55.4794 21.9476 54.9551 21.4251 54.9551 20.7781V6.66602C55.1915 6.66602 55.4172 6.75844 55.5843 6.92551L69.9807 21.322C70.1478 21.4891 70.2402 21.7148 70.2402 21.9494Z",
    fill: "#D4DCE8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.238 21.9477H66.5927L55.582 6.92383L69.9785 21.3203C70.1456 21.4874 70.238 21.7131 70.238 21.9477Z",
    fill: "#8CA5BA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.333 33.8496H54.2225C54.9586 33.8496 55.5555 33.253 55.5555 32.5166C55.5555 31.7802 54.9586 31.1836 54.2225 31.1836H22.333C21.5968 31.1836 21 31.7802 21 32.5166C21 33.253 21.5968 33.8496 22.333 33.8496Z",
    fill: "#D4DCE8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2224 39.0469H22.333C21.5968 39.0469 21 39.6435 21 40.3799C21 41.1162 21.5968 41.7129 22.333 41.7129H54.2224C54.9586 41.7129 55.5555 41.1162 55.5555 40.3799C55.5555 39.6435 54.9586 39.0469 54.2224 39.0469Z",
    fill: "#D4DCE8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.223 47.0605H47.9228C47.1867 47.0605 46.5898 47.6572 46.5898 48.3936C46.5898 49.1299 47.1867 49.7266 47.9228 49.7266H54.223C54.9592 49.7266 55.556 49.1299 55.556 48.3936C55.556 47.6572 54.9592 47.0605 54.223 47.0605Z",
    fill: "#D4DCE8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6488 47.0605H22.333C21.5968 47.0605 21 47.6572 21 48.3936C21 49.1299 21.5968 49.7266 22.333 49.7266H41.6488C42.385 49.7266 42.9818 49.1299 42.9818 48.3936C42.9818 47.6572 42.385 47.0605 41.6488 47.0605Z",
    fill: "#D4DCE8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0222 74.2601C55.0222 83.4899 47.5112 91.0009 38.2797 91.0009C37.5581 91.0009 36.8471 90.9547 36.1504 90.8659H36.1433C27.916 89.8119 21.5371 82.7665 21.5371 74.2601C21.5371 65.752 27.916 58.7066 36.1433 57.6527H36.1504C36.8471 57.5638 37.5581 57.5176 38.2797 57.5176C47.5112 57.5176 55.0222 65.0286 55.0222 74.2601Z",
    fill: "url(#paint1_linear_1671_6298)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0203 74.2601C55.0203 83.4899 47.5092 91.0009 38.2777 91.0009C37.5561 91.0009 36.8452 90.9547 36.1484 90.8659C44.3758 89.8119 50.7546 82.7665 50.7546 74.2601C50.7546 65.752 44.3758 58.7066 36.1484 57.6527C36.8452 57.5638 37.5561 57.5176 38.2777 57.5176C47.5092 57.5176 55.0203 65.0286 55.0203 74.2601Z",
    fill: "#FF6019"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.664 73.4863C43.2345 73.8797 42.5381 73.8796 42.1088 73.4864L39.1768 70.8017V80.538C39.1768 81.0943 38.6844 81.5451 38.0771 81.5451C37.4697 81.5451 36.9773 81.0943 36.9773 80.538V70.8017L34.0454 73.4864C33.6158 73.8796 32.9195 73.8797 32.4901 73.4863C32.0606 73.093 32.0606 72.4553 32.4901 72.0621L37.2994 67.6582C37.5141 67.4616 37.7957 67.3633 38.0771 67.3633C38.3585 67.3633 38.64 67.4616 38.8547 67.6582L43.664 72.0621C44.0935 72.4553 44.0935 73.093 43.664 73.4863Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1671_6298",
    x1: 63.0399,
    y1: 0.00000353822,
    x2: -17.0165,
    y2: 42.5086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE1E2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1671_6298",
    x1: 55.0222,
    y1: 57.5176,
    x2: 15.9279,
    y2: 82.0694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE1E2D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileIcon);
export default __webpack_public_path__ + "static/media/uploadFile-icon.9a57147099ac8b1c8e0f9257c658a1b7.svg";
export { ForwardRef as ReactComponent };